import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建TMS司机
export const CREATE_ACCOUNT_TMS_DRIVER = gql`
    mutation CreateAccountTmsDriver($input: AccountTmsDriverInput!) {
        createAccountTmsDriver(input: $input)
    }
`;

// 更新TMS司机
export const UPDATE_ACCOUNT_TMS_DRIVER = gql`
    mutation UpdateAccountTmsDriver($input: AccountTmsDriverInput!) {
        updateAccountTmsDriver(input: $input)
    }
`;

export interface AccountTmsDriverInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    vehicleId?: number;
    carrierId: number; // 必填字段
    role: string;
}

export const createAccountTmsDriver = async (input: AccountTmsDriverInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_TMS_DRIVER,
        variables: {input}
    });
    return data.createAccountTmsDriver;
};

export const updateAccountTmsDriver = async (input: AccountTmsDriverInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_TMS_DRIVER,
        variables: {input}
    });
    return data.updateAccountTmsDriver;
}; 